export function cddRejectOnError(response) {
  const code = response && response.data ? response.data.statusCode : undefined;
  if (typeof code === "number" && code !== 200 && code !== 201) {
    response.status = code;
    return Promise.reject(response);
  }
  return response;
}
